<div class="container mb-pdp-tab-content mb-applications-tab"
     data-cy="mb-applications-tab"
     *ngIf="product$ | async as product">

  <div *ngIf="applications$ | async as applications"
       class="mb-pdp-tab-wrapper mb-applications-wrapper">
    <div *ngFor="let application of sortBySortOrder(applications), index as i"
         class="mb-application"
         [attr.data-cy]="'mb-application-' + i">

      <mb-pdp-application-item [application]="application"
                               [productName]="productName">
      </mb-pdp-application-item>

    </div>
  </div>
</div>
